<div
   class="sam-form-row sam-full-width container sam-no-margin sam-auto-overflow"
   [ngClass]="{ 'sam-scrollbar-disabled': !(draggedItemKey | isNil | async) }"
>
   <div *ngFor="let skill of skillList">
      <div class="sam-form-flex-row sam-full-width sam-border-bottom">
         <samweb-skill-short-info
            class="skill-container"
            *ngIf="!(skill?.skillConfiguration | isNil | async)"
            [searchValue]="searchValues"
            [skills]="skill?.skillConfiguration?.skills"
            [skillConfiguration]="skill?.skillConfiguration"
         ></samweb-skill-short-info>
         <samweb-agent-greeting-configuration-ici
            class="ici-container"
            [skillId]="skill?.skillId"
            [searchValues]="searchValues"
            [disabled]="disabled"
            [draggedItemKey]="draggedItemKey"
            [availableIci]="availableIci"
            (waveFileDropped)="drop($event)"
            (removeAssignment)="remove($event)"
            (expandGroup)="expandIciGroup($event)"
         ></samweb-agent-greeting-configuration-ici>
      </div>
   </div>
</div>
